import { makeStyles } from '@material-ui/core'
import { ROUTES } from 'consts'
import { useHistory } from 'react-router'
import AppLogoIcon from './appLogo'

const useStyles = makeStyles({
  appLogo: {
    display: 'flex',
    padding: '0 20px',
    cursor: 'pointer'
  }
})

const AppLogo = () => {
  const classes = useStyles()
  const { push } = useHistory()
  return (
    <div className={classes.appLogo} onClick={() => push(ROUTES.PATIENTS)}>
      <AppLogoIcon />
    </div>
  )
}

export default AppLogo
